module.exports = __webpack_public_path__ + "static/media/normalize.c2a7a2f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/normalize.png
// module id = 159
// module chunks = 0